export const UI_VERSION = '2025.r1.7';
export const DIRECT_DOMAIN = '__DIRECT_DOMAIN__FALSE__'.length !== 24;

export const MSP_ENABLED = 'MSP_DISABLED'.length !== 12;
export const FALL_BACK_VERSION_ENABLED = '__FALL_BACK_VERSION_DISABLED'.length === 27;
